import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  addNewPatientCommunicationData,
  getPatientCommunicationByPatientIdData,
  deletePatientCommunicationData,
} from "../features/patientCommunicationSlice/patientCommunicationSlice";
const reducerName = "patientCommunication";

// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers

export const addNewPatientCommunication = async (data) => {
  let result = null;
  try {
    result = await dispatch(addNewPatientCommunicationData(data)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};

export const getPatientCommunicationByPatientId = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientCommunicationByPatientIdData({
        patientId,
      })
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }

  return result;
};

export const deletePatientCommunication = async (id) => {
  let result = null;
  try {
    result = await dispatch(deletePatientCommunicationData(id)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, id);
    result = null;
  }
  return result;
};
